var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", { staticClass: "ak-form__checkbox" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.currentValue,
          expression: "currentValue",
        },
      ],
      attrs: { type: "checkbox" },
      domProps: {
        checked: Array.isArray(_vm.currentValue)
          ? _vm._i(_vm.currentValue, null) > -1
          : _vm.currentValue,
      },
      on: {
        change: [
          function ($event) {
            var $$a = _vm.currentValue,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.currentValue = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.currentValue = $$a
                    .slice(0, $$i)
                    .concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.currentValue = $$c
            }
          },
          _vm.valueChanged,
        ],
      },
    }),
    _vm._v(" "),
    _c("span", {
      staticClass: "ak-form__checkmark ak-form__checkmark--checkbox",
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }